<template>
  <div id="app" class="d-flex flex-column">
    <fan-village/>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueCookies from 'vue-cookies'

import FanVillage from '@/components/FanVillage.vue'

import './styles/master.scss'

Vue.use(BootstrapVue)
Vue.use(VueCookies)

Vue.directive('i18n', function (el, binding, vnode) {
	if (binding.modifiers.dictionary) {
		el.innerHTML = binding.value[vnode.context.$root.lang.id];
	} else if (binding.arg == vnode.context.$root.lang.id) {
		if (Object.keys(binding.modifiers).length) {
			el.setAttribute(Object.keys(binding.modifiers)[0], binding.value);
			return;
		}
		el.innerHTML = binding.value;
	}
});

export default {
	computed: {},
	components: {
		FanVillage
	}
}
</script>

<style lang="scss">
	#app {min-height:100vh;}
</style>
